import React from 'react';
import { Alert, Platform } from 'react-native';
import { EmailPasswordScreen, TermsScreen, AccountTypeScreen, VerifyBusinessScreen, PersonalProfileScreen, VerifyIdentityScreen, CompanyProfileScreen, MoneyScreen, EmergencyContactsScreen } from './SignUp';
import * as ImagePicker from 'expo-image-picker';
import { createStackNavigator } from '@react-navigation/stack';
import NavOptions from '../constants/NavOptions';
import { getImageFieldsForUpload } from '../utils/Functions';
import * as Application from 'expo-application';
// import * as SecureStore from 'expo-secure-store';
import * as rtApi from '../components/Api';
import UserState from '../src/contexts/UserState';
import { processLoginAccount, dataUrlToFile, isImageExtensionValid } from '../utils/Functions';
import { Storage } from '../components';
import moment from 'moment';
import { useLinkTo } from '@react-navigation/native';

const SignUpStack = ({ navigation, route }) => {
  const [user, setUser] = React.useContext(UserState);
  const [accountType, setAccountType] = React.useState('Email');
  const [uniqueDevice, setUniqueDevice] = React.useState(null);
  
  // email password
  const [username, setUsername] = React.useState('');
  const [emailAddress, setEmailAddress] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [confirmPassword, setConfirmPassword] = React.useState('');
  // terms
  const [confirmedTerms, setConfirmedTerms] = React.useState(false);
  const [signature, setSignature] = React.useState(null);
  const [signatureText, setSignatureText] = React.useState('');
  //account type
  const [isContractor, setIsContractor] = React.useState(false);
  const [structure, setStructure] = React.useState('Sole Proprietorship');
  const [businessNumber, setBusinessNumber] = React.useState('');
  const [legalName, setLegalName] = React.useState('');
  const [legalAddress, setLegalAddress] = React.useState('');
  const [legalAddressNumber, setLegalAddressNumber] = React.useState('');
  const [legalAddressUnit, setLegalAddressUnit] = React.useState('');
  const [legalStreetId, setLegalStreetId] = React.useState('');
  const [legalZipCode, setLegalZipCode] = React.useState(null);
  const [legalCountry, setLegalCountry] = React.useState(null);
  const [legallyBindCompany, setLegallyBindCompany] = React.useState(false);
  // verify business
  const [businessId, setBusinessId] = React.useState(null);
  // personal profile
  const [avatar, setAvatar] = React.useState(null);
  const [firstName, setFirstName] = React.useState('');
  const [lastName, setLastName] = React.useState('');
  const [hasMobile, setHasMobile] = React.useState(true);
  const [mobileNumber, setMobileNumber] = React.useState('');
  const [houseNumber, setHouseNumber] = React.useState('');
  const [address, setAddress] = React.useState('');
  const [streetId, setStreetId] = React.useState(null);
  const [zipCode, setZipCode] = React.useState(null);
  const [streetNumber, setStreetNumber] = React.useState(null);
  const [addressUnit, setAddressUnit] = React.useState(null);
  const [longitude, setLongitude] = React.useState(null);
  const [latitude, setLatitude] = React.useState(null);
  const [country, setCountry] = React.useState(null);
  // const [isContractor, setIsContractor] = React.useState(false);
  // verify identity
  const [photoIds, setPhotoIds] = React.useState([]);
  // contractor
  const [logo, setLogo] = React.useState(null);
  const [companyName, setCompanyName] = React.useState('');
  const [bio, setBio] = React.useState('');
  const [projectGallery, setProjectGallery] = React.useState([]);
  const [contractorEmailAddress, setContractorEmailAddress] = React.useState('');
  const [contractorPhoneNumber, setContractorPhoneNumber] = React.useState('');
  const [contractorAddress, setContractorAddress] = React.useState('');
  const [contractorStreetId, setContractorStreetId] = React.useState(null);
  const [contractorZipCode, setContractorZipCode] = React.useState(null);
  const [contractorStreetNumber, setContractorStreetNumber] = React.useState(null);
  const [contractorAddressUnit, setContractorAddressUnit] = React.useState(null);
  const [contractorCountry, setContractorCountry] = React.useState(null);
  const [website, setWebsite] = React.useState('');
  const [insurance, setInsurance] = React.useState(false);
  const [insuranceIssuer, setInsuranceIssuer] = React.useState('');
  const [insurancePolicy, setInsurancePolicy] = React.useState('');
  const [insuranceExpiry, setInsuranceExpiry] = React.useState(new Date());
  const [insuranceExpiryChanged, setInsuranceExpiryChanged] = React.useState(false);
  // const [license, setLicense] = React.useState('');
  const [serviceAreas, setServiceAreas] = React.useState([]);
  const [preferredPaymentIdentity, setPreferredPaymentIdentity] = React.useState('personal');
  // const [skills, setSkills] = React.useState([]);
  //money
  const [moneyMethod, setMoneyMethod] = React.useState(null);
  // const [transitNo, setTransitNo] = React.useState(null);
  // const [institutionNo, setInstitutionNo] = React.useState(null);
  // const [accountNo, setAccountNo] = React.useState(null);
  const [accountId, setAccountId] = React.useState(null);
  const [accountMask, setAccountMask] = React.useState(null);
  const [accessToken, setAccessToken] = React.useState(null);
  const [itemId, setItemId] = React.useState(null);
  // emergency contacts
  const [emergencyContact1, setEmergencyContact1] = React.useState({ name: '', phone: '', email: '', relationship: '', });
  const [emergencyContact2, setEmergencyContact2] = React.useState({ name: '', phone: '', email: '', relationship: '', });
  const [skipEmergency, setSkipEmergency] = React.useState(false);

  const [signUpProgress, setSignUpProgress] = React.useState({
    EmailPassword: false,
    Terms: false,
    AccountType: false,
    VerifyBusiness: false,
    CompanyProfile: false,
    PersonalProfile: false,
    VerifyIdentity: false,
    EmergencyContacts: false,
    Money: false,
  });

  const Stack = createStackNavigator();
  const linkTo = useLinkTo();

  // facebook user
  // React.useEffect(() => {
  //   console.log('SignUpStack useEffect', route.params);
  //   try{
  //     let userField = '';
  //     if (route.params && route.params.fbUser){
  //       userField = 'fbUser';
  //       setAccountType('Facebook');
  //     } else if (route.params && route.params.googleUser){
  //       userField = 'googleUser';
  //       setAccountType('Google');
  //     } else if (route.params && route.params.appleUser){
  //       userField = 'appleUser';
  //       setAccountType('Apple');
  //     }
  //     console.log('userField', userField);
  //     if(userField){
  //       console.log('route.params.socialUser', route.params[userField]);
  //       if (route.params[userField].avatar){
  //         setAvatar({ uri: route.params[userField].avatar });
  //       }
  //       if (route.params[userField].name){
  //         const names = route.params[userField].name.split(' ');
  //         const fName = names[0];
  //         setFirstName(fName);
  //         if(names.length > 1){
  //           const lName = names[names.length - 1];
  //           setLastName(lName);
  //         }
  //       }
  //       if (route.params[userField].email){
  //         setEmailAddress(route.params[userField].email);
  //       }
  //       if (route.params[userField].id) {
  //         setUsername(route.params[userField].id);
  //         // navigation.navigate('Terms');
  //         console.log('link to terms');
  //         // linkTo('/signup/terms');
  //       }
  //     }
  //   }catch(err){
  //     console.log(err);
  //   }
  // }, [route.params.fbUser, route.params.googleUser, route.params.appleUser]);

  React.useEffect(() => {
    console.log('useEffect socialuser: ', route.params?.socialUser)
    if (route.params?.socialUser) {
      processSocialUser(route.params.socialUser);
    }
  }, [route.params?.socialUser]);

  React.useEffect(() => {
    getUniqueDevice();
  });

  React.useEffect(() => {
    return () => rtApi.cancel();
  });

  // React.useEffect(() => {
  //   console.log('navigation.state: ', navigation.state);
  // }, []);

  const processSocialUser = (sUser) => {
    console.log('processSocialUser: ', sUser);
    setAccountType(sUser.type);
    if (sUser.avatar) {
      setAvatar({ uri: sUser.avatar });
    }
    if (sUser.name) {
      const names = sUser.name.split(' ');
      const fName = names[0];
      setFirstName(fName);
      if (names.length > 1) {
        const lName = names[names.length - 1];
        setLastName(lName);
      }
    }
    if (sUser.email) {
      setEmailAddress(sUser.email);
    }
    if (sUser.id) {
      setUsername(sUser.id);
    }
    completeStep('EmailPassword');
  }

  const getUniqueDevice = async () => {
    if (Platform.OS === 'ios') {
      setUniqueDevice(await Application.getIosIdForVendorAsync());
    } else if (Platform.OS === 'android') {
      setUniqueDevice(Application.androidId);
    }
  }

  const completeStep = (step) => {
    // personal
    // EmailPassword -> Terms -> AccountType -> PersonalProfile -> VerifyIdentity -> EmergencyContacts

    // contractor
    // EmailPassword -> Terms -> AccountType -> VerifyBusiness -> CompanyProfile -> PersonalProfile -> VerifyIdentity -> EmergencyContacts -> Money
    console.log('completeStep()', step);
    switch (step) {
      case 'EmailPassword':
        setSignUpProgress(existingState => ({
          ...existingState,
          EmailPassword: true,
        }));
        // return navigation.navigate('Terms');
        return linkTo('/signup/terms');
      case 'Terms':
        setSignUpProgress(existingState => ({
          ...existingState,
          Terms: true,
        }));
        // return navigation.navigate('AccountType');
        return linkTo('/signup/accounttype');
      case 'AccountType':
        setSignUpProgress(existingState => ({
          ...existingState,
          AccountType: true,
        }));
        // return navigation.navigate(isContractor ? ((structure === 'Individual') ? 'CompanyProfile' : 'VerifyBusiness') : 'PersonalProfile');
        return linkTo(isContractor ? ((structure === 'Individual') ? '/signup/companyprofile' : '/signup/verifybusiness') : '/signup/personalprofile');
      case 'VerifyBusiness':
        setSignUpProgress(existingState => ({
          ...existingState,
          VerifyBusiness: true,
        }));
        // return navigation.navigate('CompanyProfile');
        return linkTo('/signup/companyprofile');
      case 'CompanyProfile':
        setSignUpProgress(existingState => ({
          ...existingState,
          CompanyProfile: true,
        }));
        // return navigation.navigate('PersonalProfile');
        return linkTo('/signup/personalprofile');
      case 'PersonalProfile':
        setSignUpProgress(existingState => ({
          ...existingState,
          PersonalProfile: true,
        }));
        // return navigation.navigate('VerifyIdentity');
        return linkTo('/signup/verifyidentity');
      case 'VerifyIdentity':
        setSignUpProgress(existingState => ({
          ...existingState,
          VerifyIdentity: true,
        }));
        // return navigation.navigate('EmergencyContacts');
        return linkTo('/signup/emergencycontacts');
      case 'EmergencyContacts':
        setSignUpProgress(existingState => ({
          ...existingState,
          EmergencyContacts: true,
        }));
        // return navigation.navigate('Money');
        return linkTo('/signup/money');
      default:
        // return navigation.navigate('EmailPassword');
        return linkTo('/signup/emailpassword');
    }
    console.log('completeStep()2', signUpProgress);
  }

  // photo stuff
  const chooseAvatarPhoto = async () => {
    // if (Constants.platform.ios) {
    let permissionResult = await ImagePicker.requestMediaLibraryPermissionsAsync();
    // }
    if (permissionResult.granted === false) {
      Alert.alert("Permission to access camera roll is required!");
      return;
    }
    setAvatar(null);
    let result = await ImagePicker.launchImageLibraryAsync({
      mediaTypes: ImagePicker.MediaTypeOptions.Images,
      allowsEditing: true,
      aspect: [1, 1],
      quality: 1,
    });
    if (!result.canceled) {
      if (Platform.OS === 'web') {
        result.assets[0].file = await dataUrlToFile(result.assets[0].uri);
      }
      const isValidExtension = isImageExtensionValid(Platform.OS === 'web' ? result.assets[0].file.name : result.assets[0].uri);
      if (!isValidExtension.result) {
        // setAlertOptions({ visible: true, title: 'Error', message: `Invalid image type. Images must end in one of the following extensions: ${isValidExtension.extensions}`, });
        alert(`Invalid image type. Images must end in one of the following extensions: ${isValidExtension.extensions}`);
        return;
      }
      console.log(result);
      // setAvatar(result.uri);
      setAvatar(result.assets[0]);
    }else{
      setAvatar(null);
    }
  };
  const removePhotoId = (uri) => {
    setPhotoIds(prevState => {
      return prevState.filter(id => {
        return id.uri !== uri;
      });
    })
  };
  const removeBusinessId = (uri) => {
    console.log('removeBusinessId: ', uri);
    setBusinessId(null);
  }

  const buildFormData = () => {
    console.log('building formData');
    let fd = new FormData();
    fd.append('account_type', accountType);
    fd.append('email_address', emailAddress);
    if (accountType === 'Email') {
      fd.append('password', password);
      fd.append('confirm_password', confirmPassword);
      fd.append('username', emailAddress);
    } else {
      fd.append('username', username);
    }
    if (hasMobile) {
      fd.append('phone_number_mobile', mobileNumber);
    } else {
      fd.append('phone_number_home', houseNumber);
    }
    fd.append('first_name', firstName);
    fd.append('last_name', lastName);
    fd.append('street_id', streetId);
    fd.append('address_number', streetNumber);
    if(addressUnit){
      fd.append('address_unit', addressUnit);
    }
    if (avatar) {
      console.log('avatar_file', avatar);
      if(Platform.OS !== 'web'){
        let avatarDetails = getImageFieldsForUpload(avatar.uri);
        fd.append('avatar_file', {
          uri: avatar.uri,
          name: avatarDetails.filename,
          type: avatarDetails.type,
        });
      }else{
        fd.append('avatar_file', avatar.file)
      }
    }
    photoIds.forEach((p, i) => {
      console.log('photoId', p);
      // fd.append('photo_id[]', p);
      if(Platform.OS !== 'web'){
        let idDetails = getImageFieldsForUpload(p.uri);
        fd.append(`government_id${i + 1}`, {
          uri: p.uri,
          name: idDetails.filename,
          type: idDetails.type,
        });
      }else{
        fd.append(`government_id${i + 1}`, p.file);
      }
    });
    if (longitude) {
      fd.append('longitude', longitude);
    }
    if (latitude) {
      fd.append('latitude', latitude);
    }
    if((structure === 'Corporation' || structure === 'Partnership') && legallyBindCompany){
      fd.append('legally_bind_company', 'Yes');
    }
    if(isContractor){
      // contractor(company)
      let company = {};
      company.name = companyName;
      company.bio = bio;
      company.email_address = contractorEmailAddress;
      company.phone_number = contractorPhoneNumber;
      company.street_id = contractorStreetId;
      company.address_number = contractorStreetNumber;
      company.structure = structure;
      if(businessNumber){
        company.business_number = businessNumber;
      }
      if(legalName){
        company.legal_name = legalName;
      }
      if(legalAddressNumber){
        company.legal_address_number = legalAddressNumber;
      }
      if(legalAddressUnit){
        company.legal_address_unit = legalAddressUnit;
      }
      if(legalStreetId){
        company.legal_street_id = legalStreetId;
      }
      company.insurance = insurance ? 'Yes' : 'No';
      if(insurance){
        if (insuranceIssuer){
          company.insurance_insurer = insuranceIssuer;
        }
        if (insurancePolicy){
          company.insurance_policy = insurancePolicy;
        }
        if (insuranceExpiryChanged && insuranceExpiry){
          company.insurance_expiry = Platform.OS === 'web' ? insuranceExpiry : moment(insuranceExpiry).format('YYYY-MM-DD');
        }
      }
      // company.license = license;
      // company.zip_code = contractorZipCode;
      if(contractorAddressUnit){
        company.address_unit = contractorAddressUnit;
      }
      if(website){
        company.website = website;
      }
      company.service_areas = [];
      serviceAreas.forEach((s) => {
        company.service_areas.push(s.id);
      });
      company.project_gallery_count = projectGallery.length;
      // company.skills = [];
      // skills.forEach((s) => {
      //   company.skills.push(s);
      // });
      console.log('formData company: ', company);
      fd.append('company', JSON.stringify(company));
      // contractor logo
      if (logo) {
        console.log('logo', logo);
        if (Platform.OS !== 'web') {
          let logoDetails = getImageFieldsForUpload(logo.uri);
          fd.append('logo', {
            uri: logo.uri,
            name: logoDetails.filename,
            type: logoDetails.type,
          });
        }else{
          fd.append('logo', logo.file)
        }
      }
      // contractor business id
      if (businessId) {
        console.log('logo', logo);
        if (Platform.OS !== 'web') {
          let details = getImageFieldsForUpload(businessId.uri);
          fd.append('business_id', {
            uri: businessId.uri,
            name: details.filename,
            type: details.type,
          });
        }else{
          fd.append('business_id', businessId.file)
        }
      }
      // contractor project gallery
      projectGallery.forEach((p, i) => {
        console.log('Project Gallery', p);
        if (Platform.OS !== 'web') {
          let projectGalleryDetails = getImageFieldsForUpload(p.uri);
          fd.append(`project_gallery${(i + 1)}`, {
            uri: p.uri,
            name: projectGalleryDetails.filename,
            type: projectGalleryDetails.type,
          });
        }else{
          fd.append(`project_gallery${(i + 1)}`, p.file);
        }
      });
      // money
      fd.append('preferred_payment_method', moneyMethod);
      if (moneyMethod === 'direct deposit' && Platform.OS !== 'web') {
        // fd.append('transit_number', transitNo);
        // fd.append('institution_number', institutionNo);
        // fd.append('account_number', accountNo);
        fd.append('account_id', accountId);
        fd.append('account_mask', accountMask);
        fd.append('access_token', accessToken);
        fd.append('item_id', itemId);
      }
      if (moneyMethod === 'mail' || moneyMethod === 'e-transfer') {
        fd.append('preferred_payment_identity', preferredPaymentIdentity);
      }
    }

    fd.append('unique_device', uniqueDevice);
    fd.append('customer_type', isContractor ? 'Contractor' : 'Homeowner');

    // emergency
    if(!skipEmergency){
      fd.append('emergency1_name', emergencyContact1.name);
      fd.append('emergency1_email_address', emergencyContact1.email);
      fd.append('emergency1_phone_number', emergencyContact1.phone);
      fd.append('emergency1_relationship', emergencyContact1.relationship);
      fd.append('emergency2_name', emergencyContact2.name);
      fd.append('emergency2_email_address', emergencyContact2.email);
      fd.append('emergency2_phone_number', emergencyContact2.phone);
      fd.append('emergency2_relationship', emergencyContact2.relationship);
    }

    // terms
    if (Platform.OS !== 'web' && signature) {
      console.log('signature: ', signature);
      let imgDetails = getImageFieldsForUpload(signature.uri);
      fd.append('signature', {
        uri: signature.uri,
        name: imgDetails.filename,
        type: imgDetails.type,
      });
    }
    if (Platform.OS === 'web' && signatureText) {
      fd.append('signature_name', signatureText);
    }

    // console.log('FormData POST Values:');
    // console.log(...fd);
    // for (var value of fd.entries()) {
    //   console.log(value[0] + ': ' + value[1]);
    // }

    return fd;
  }
  const confirmDetails = async () => {
    console.log('confirmDetails');
    const fd = buildFormData();
    console.log('formData is built');
    // return false;

    return rtApi.post('users', fd)
    .then(data => {
      if (data.notLoggedIn) { setUser({ isLoggedIn: false }); rtApi.cancel(); return; }
      console.log('confirmDetails data', data);
      if (data.result) {
        // let emailUser = data.session.account;
        // emailUser.avatar = (emailUser.avatar === 'Yes') ? getAvatarUrl(emailUser.id) : null;
        let u = processLoginAccount(data.session.account, false);
        finishSignUp(u);
      } else {
        throw (data.errors.join('; '));
      }
    }).catch((error) => {
      console.log('confirmDetails catch', error);
      console.log(error);
      throw(error);
    });
  };

  const finishSignUp = async (u) => {
    console.log('finishSignUp user', user, emailAddress, password);
    if(u.type === 'Email'){
      await Promise.all([
        // SecureStore.setItemAsync('username', String(emailAddress)),
        // SecureStore.setItemAsync('password', String(password)),
        // SecureStore.deleteItemAsync('useLocalAuthentication'),
        Storage.setItem('username', String(emailAddress)),
        Storage.setItem('password', String(password)),
        Storage.removeItem('useLocalAuthentication'),
      ]);
    }else{
      await Promise.all([
        // SecureStore.deleteItemAsync('username'),
        // SecureStore.deleteItemAsync('password'),
        // SecureStore.setItemAsync('useLocalAuthentication', 'no'),
        Storage.removeItem('username'),
        Storage.removeItem('password'),
        Storage.setItem('useLocalAuthentication', 'no'),
      ]);
    }
    
    setUser(u);

    // let screenToNavigateTo = isContractor ? 'Customers' : 'Contractors';
    // navigation.navigate('MoreDrawer', {
    //   screen: 'MainTabs',
    //   params: {
    //     screen: screenToNavigateTo,
    //     initial: false,
    //   }
    // });
    // linkTo(`/${isContractor ? 'customers' : 'contractors'}`);
    // linkTo(`/projects'}`);
    try{
      if(window.sessionStorage){
        const link = window.sessionStorage.rtProjectDeepLink;
        if(link === undefined || !link){
          linkTo('/projects/create_project_tutorial');
        }
      }
    }catch(err){
      console.log(err);
    }
    return true;
  };

  return (
    // EmailPassword //production
    // Terms
    // AccountType
    // VerifyBusiness
    // CompanyProfile
    // PersonalProfile
    // VerifyIdentity
    // EmergencyContacts
    // Money
    <Stack.Navigator initialRouteName={accountType === 'Email' ? 'EmailPassword' : 'Terms'} screenOptions={NavOptions.signUp}>
      {/* {accountType === 'Email' && */}
        {/* // EmailPassword */}
        <Stack.Screen
          name='EmailPassword'
          options={{
            title: accountType === 'Email' ? 'Sign Up - Email Password' : 'Sign Up - Email'
          }}
        >
          {props => 
            <EmailPasswordScreen 
              {...props} 
              setEmailAddress={setEmailAddress}
              setUsername={setUsername}
              setPassword={setPassword}
              setConfirmPassword={setConfirmPassword}
              completeStep={completeStep}
              emailAddress={emailAddress} 
              username={username} 
              password={password} 
              confirmPassword={confirmPassword} 
              accountType={accountType}
              setContractorEmailAddress={setContractorEmailAddress}
            />
          }
        </Stack.Screen>
      {/* } */}
      {/* Terms */}
      <Stack.Screen
        name='Terms'
        options={{
          title: 'Sign Up - Terms of Use'
        }}
      >
        {props => 
          <TermsScreen
            {...props} 
            setConfirmedTerms={setConfirmedTerms}
            completeStep={completeStep}
            signUpProgress={signUpProgress}
            signature={signature}
            setSignature={setSignature}
            signatureText={signatureText}
            setSignatureText={setSignatureText}
          />
        }
      </Stack.Screen>
      {/* AccountType */}
      <Stack.Screen
        name='AccountType'
        options={{
          title: 'Sign Up - Account Type'
        }}
      >
        {props =>
          <AccountTypeScreen
            {...props}
            setIsContractor={setIsContractor}
            setStructure={setStructure}
            setBusinessNumber={setBusinessNumber}
            setLegalName={setLegalName}
            setLegalAddress={setLegalAddress}
            setLegalAddressNumber={setLegalAddressNumber}
            setLegalAddressUnit={setLegalAddressUnit}
            setLegalStreetId={setLegalStreetId}
            setLegalCountry={setLegalCountry}
            setLegalZipCode={setLegalZipCode}
            setContractorAddress={setContractorAddress}
            setContractorStreetId={setContractorStreetId}
            setContractorStreetNumber={setContractorStreetNumber}
            setContractorAddressUnit={setContractorAddressUnit}
            setContractorCountry={setContractorCountry}
            setContractorZipCode={setContractorZipCode}
            // contractorStreetId={contractorStreetId}
            setCompanyName={setCompanyName}
            isContractor={isContractor}
            structure={structure}
            businessNumber={businessNumber}
            legalName={legalName}
            legalAddress={legalAddress}
            legalAddressNumber={legalAddressNumber}
            legalAddressUnit={legalAddressUnit}
            legalStreetId={legalStreetId}
            legalCountry={legalCountry}
            legalZipCode={legalZipCode}
            completeStep={completeStep}
            setPreferredPaymentIdentity={setPreferredPaymentIdentity}
            signUpProgress={signUpProgress}
            legallyBindCompany={legallyBindCompany}
            setLegallyBindCompany={setLegallyBindCompany}
          />
        }
      </Stack.Screen>
      {/* VerifyBusiness */}
      <Stack.Screen
        name='VerifyBusiness'
        options={{
          title: 'Sign Up - Verify Business'
        }}
      >
        {props =>
          <VerifyBusinessScreen
            {...props}
            removeBusinessId={removeBusinessId}
            setBusinessId={setBusinessId}
            businessId={businessId}
            completeStep={completeStep}
            structure={structure}
            signUpProgress={signUpProgress}
          />
        }
      </Stack.Screen>
      {/* CompanyProfile */}
      <Stack.Screen
        name='CompanyProfile'
        options={{
          title: 'Sign Up - Company Profile',
          headerShown: false,
        }}
      >
        {props =>
          <CompanyProfileScreen
            {...props}
            completeStep={completeStep}
            logo={logo}
            companyName={companyName}
            bio={bio}
            projectGallery={projectGallery}
            contractorEmailAddress={contractorEmailAddress}
            contractorPhoneNumber={contractorPhoneNumber}
            contractorAddress={contractorAddress}
            contractorStreetId={contractorStreetId}
            website={website}
            serviceAreas={serviceAreas}
            // skills={skills}
            setLogo={setLogo}
            setCompanyName={setCompanyName}
            setBio={setBio}
            setProjectGallery={setProjectGallery}
            setContractorEmailAddress={setContractorEmailAddress}
            setContractorPhoneNumber={setContractorPhoneNumber}
            setContractorAddress={setContractorAddress}
            setContractorStreetId={setContractorStreetId}
            setContractorStreetNumber={setContractorStreetNumber}
            setContractorZipCode={setContractorZipCode}
            setContractorAddressUnit={setContractorAddressUnit}
            setContractorCountry={setContractorCountry}
            setWebsite={setWebsite}
            setServiceAreas={setServiceAreas}
            // legalAddress={legalAddress}
            // legalAddressNumber={legalAddressNumber}
            // legalAddressUnit={legalAddressUnit}
            // legalStreetId={legalStreetId}
            insurance={insurance}
            setInsurance={setInsurance}
            insuranceIssuer={insuranceIssuer}
            setInsuranceIssuer={setInsuranceIssuer}
            insurancePolicy={insurancePolicy}
            setInsurancePolicy={setInsurancePolicy}
            insuranceExpiry={insuranceExpiry}
            setInsuranceExpiry={setInsuranceExpiry}
            setInsuranceExpiryChanged={setInsuranceExpiryChanged}
          // license={license}
          // setLicense={setLicense}
          // setSkills={setSkills}
            signUpProgress={signUpProgress}
            structure={structure}
          />
        }
      </Stack.Screen>
      {/* PersonalProfile */}
      <Stack.Screen
        name='PersonalProfile'
        options={{
          title: 'Sign Up - Personal Profile'
        }}
      >
        {props =>
          <PersonalProfileScreen
            {...props}
            setAvatar={setAvatar}
            setFirstName={setFirstName}
            setLastName={setLastName}
            setHasMobile={setHasMobile}
            setMobileNumber={setMobileNumber}
            setHouseNumber={setHouseNumber}
            setContractorPhoneNumber={setContractorPhoneNumber}
            setAddress={setAddress}
            setStreetId={setStreetId}
            setZipCode={setZipCode}
            setStreetNumber={setStreetNumber}
            setAddressUnit={setAddressUnit}
            setCountry={setCountry}
            setLongitude={setLongitude}
            setLatitude={setLatitude}
            // setIsContractor={setIsContractor}
            chooseAvatarPhoto={chooseAvatarPhoto}
            completeStep={completeStep}
            setEmailAddress={setEmailAddress}
            setContractorEmailAddress={setContractorEmailAddress}
            avatar={avatar}
            hasMobile={hasMobile}
            address={address}
            streetId={streetId}
            firstName={firstName}
            lastName={lastName}
            mobileNumber={mobileNumber}
            houseNumber={houseNumber}
            emailAddress={emailAddress}
            accountType={accountType}
            signUpProgress={signUpProgress}
            isContractor={isContractor}
          />
        }
      </Stack.Screen>
      {/* VerifyIdentity */}
      <Stack.Screen
        name='VerifyIdentity'
        options={{
          title: 'Sign Up - Verify Identity'
        }}
      >
        {props =>
          <VerifyIdentityScreen
            {...props}
            removePhotoId={removePhotoId}
            completeStep={completeStep}
            confirmDetails={confirmDetails}
            setPhotoIds={setPhotoIds}
            photoIds={photoIds}
            isContractor={isContractor}
            signUpProgress={signUpProgress}
          />}
      </Stack.Screen>
      {/* EmergencyContacts */}
      <Stack.Screen
        name='EmergencyContacts'
        options={{
          title: 'Sign Up - Emergency Contacts'
        }}
      >
        {props =>
          <EmergencyContactsScreen
            {...props}
            emergencyContact1={emergencyContact1}
            setEmergencyContact1={setEmergencyContact1}
            emergencyContact2={emergencyContact2}
            setEmergencyContact2={setEmergencyContact2}
            setSkipEmergency={setSkipEmergency}
            confirmDetails={confirmDetails}
            isContractor={isContractor}
            completeStep={completeStep}
            signUpProgress={signUpProgress}
          />
        }
      </Stack.Screen>
      {/* Money */}
      <Stack.Screen
        name='Money'
        options={{
          title: 'Sign Up - Receiving Money'
        }}
      >
        {props =>
          <MoneyScreen
            {...props}
            setMoneyMethod={setMoneyMethod}
            // setTransitNo={setTransitNo}
            // setInstitutionNo={setInstitutionNo}
            // setAccountNo={setAccountNo}
            setAccountId={setAccountId}
            setAccountMask={setAccountMask}
            setAccessToken={setAccessToken}
            setItemId={setItemId}
            confirmDetails={confirmDetails}
            completeStep={completeStep}
            moneyMethod={moneyMethod}
            // transitNo={transitNo}
            // institutionNo={institutionNo}
            // accountNo={accountNo}
            accountId={accountId}
            accountMask={accountMask}
            accessToken={accessToken}
            itemId={itemId}
            firstName={firstName}
            lastName={lastName}
            address={address}
            zipCode={zipCode}
            country={country}
            emailAddress={emailAddress}
            companyName={companyName}
            contractorAddress={contractorAddress}
            contractorCountry={contractorCountry}
            contractorZipCode={contractorZipCode}
            preferredPaymentIdentity={preferredPaymentIdentity}
            setPreferredPaymentIdentity={setPreferredPaymentIdentity}
            contractorEmailAddress={contractorEmailAddress}
            type='Sign Up'
            signUpProgress={signUpProgress}
            structure={structure}
          />
        }
      </Stack.Screen>  
    </Stack.Navigator>  
  );

}

export default SignUpStack;